export default __webpack_public_path__ + "static/media/oliver.ba094c99.svg";